/*
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../..//widget/renderSequence/api/RenderStepProviderAPI',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../visualizations/renderer/sequence/KeyDriversTask'
], function(RenderStepProviderAPI, APIFactory, KeyDriversTask) {

	class KeyDriversProvider {
		constructor(options) {
			// RenderSequence is a dependency so it is automatically passed in
			options.features.RenderSequence.registerRenderStepProvider(this.getAPI());
		}

		destroy() {}

		getAPI() {
			if (!this.api) {
				this.api = APIFactory.createAPI(this, [RenderStepProviderAPI]);
			}
			return this.api;
		}

		getRenderStepList() {
			return [
				{
					id: 'keyDrivers',
					dependencies:['visSpec'],
					blocks:['data'],
					module: KeyDriversTask
				}
			];
		}
	}

	return KeyDriversProvider;
});
